import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import { IonPopover, PopoverController } from '@ionic/angular/standalone'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { ISearch, ISearchItem } from './models/search.model'

@Component({
  selector: 'slp-search',
  templateUrl: 'slp-search.component.html',
  styleUrls: ['slp-search.component.scss'],
})
export class SlpSearchComponent implements OnInit {
  @Input() public searchOptions: ISearchItem[]
  @Input() public search: ISearch

  @Output() doSearch = new EventEmitter<ISearch>()

  selectedOption: ISearchItem
  valueControl = new FormControl()
  @ViewChild('popoverDom') popoverDom: IonPopover
  private debounce = 600

  constructor(private popoverController: PopoverController) {}

  ngOnInit(): void {
    if (!this.searchOptions || this.searchOptions.length == 0)
      throw new Error('please define the searchOptions input variable in component')

    this.selectedOption = this.searchOptions[0]

    if (!this.search) this.search = { column: '', value: '' }
    if (this.search.value) this.valueControl.setValue(this.search.value)
    if (this.search.column) this.selectedOption = this.searchOptions.filter((q) => q.column == this.search.column)[0]

    this.valueControl.valueChanges.pipe(debounceTime(this.debounce), distinctUntilChanged()).subscribe(() => {
      this.triggerSearch()
    })
  }

  async clickOption(index: number): Promise<void> {
    await this.popoverController.dismiss()
    this.valueControl.setValue('')
    this.selectedOption = this.searchOptions.splice(index, 1)[0]
    this.searchOptions.sort((a, b) => a.ordinal - b.ordinal)
  }

  triggerPopover(event: MouseEvent): void {
    const rect: DOMRect = (event.target as HTMLElement).getBoundingClientRect()
    const newEvent = new MouseEvent('newMouseEvent', {
      ...event,
      clientX: rect.left,
      clientY: rect.top + rect.height,
    })
    void this.popoverDom.present(newEvent)
  }

  triggerSearch(): void {
    this.search.column = this.selectedOption.column
    this.search.value = this.valueControl.value as string
    this.doSearch.emit(this.search)
  }

  clearSearch(): void {
    this.valueControl.setValue('')
    this.selectedOption = this.searchOptions[0]
  }
}
